import { UIFactory } from '../types';

export const uiFactory: UIFactory = uiModule => uiModule;
